/* Resolve a catalog SKU to a real Shopify variant. */
(function (scope) {
  class StullerCommerce {
    constructor({
      fetcher = fetch,
      origin = location.origin,
      route = '/'
    } = {}) {
      this.fetcher = fetcher;
      this.origin = origin;
      this.route = route.endsWith('/') ? route : route + '/';
      this.indexes = new Map();
    }

    url(handle) {
      if (!/^dlux-stuller-\d+-catalog-\d+$/.test(handle)) {
        throw Error('Invalid catalog product');
      }

      const url = new URL(
        this.route + 'products/' + handle,
        this.origin
      );
      url.searchParams.set('view', 'stuller-resolve');
      return url;
    }

    async read(url) {
      const response = await this.fetcher(url.toString(), {
        credentials: 'same-origin',
        cache: 'no-store',
    headers: { Accept: 'text/html' }
      });

      if (!response.ok) {
        throw Error('Shopify configuration is unavailable');
      }

      return response.json();
    }

    async buildIndex(handle) {
      const base = this.url(handle);
      let url = base;
      const visited = new Set();
      const index = new Map();

      while (url) {
        if (visited.has(url.toString()) || visited.size >= 50) {
          throw Error('Shopify pagination could not be verified');
        }
        visited.add(url.toString());

        const payload = await this.read(url);

        if (
          payload.handle !== handle ||
          !Array.isArray(payload.variants)
        ) {
throw Error(
  'Esperado: ' + handle +
  ' | Recibido: ' + String(payload.handle) +
  ' | Lista de variantes: ' + Array.isArray(payload.variants)
);
        }

        for (const variant of payload.variants) {
          if (!variant.sku) continue;

          const id = String(variant.id);
          if (!/^\d+$/.test(id)) {
            throw Error('Invalid Shopify variant');
          }

          if (index.has(variant.sku)) {
            throw Error('Duplicate SKU in Shopify');
          }

          index.set(variant.sku, id);
        }

        if (!payload.nextPage) break;

        const next = new URL(payload.nextPage, base);
        if (
          next.origin !== base.origin ||
          next.pathname !== base.pathname
        ) {
          throw Error('Invalid Shopify pagination');
        }

        next.searchParams.set('view', 'stuller-resolve');
        next.searchParams.delete('variant');
        next.searchParams.delete('option_values');
        url = next;
      }

      return index;
    }

    async resolve(row) {
      const handle = row.catalogHandle;

      if (!this.indexes.has(handle)) {
        const pending = this.buildIndex(handle).catch(error => {
          this.indexes.delete(handle);
          throw error;
        });
        this.indexes.set(handle, pending);
      }

      const index = await this.indexes.get(handle);
      const id = index.get(row.sku);

      if (!id) {
        throw Error('SKU is missing from Shopify');
      }

      const url = this.url(handle);
      url.searchParams.set('variant', id);

      const payload = await this.read(url);
      const variant = payload.variant;

      if (
        payload.handle !== handle ||
        !variant ||
        variant.sku !== row.sku ||
        String(variant.id) !== id ||
        !Number.isSafeInteger(variant.price) ||
        variant.price < 0
      ) {
        this.indexes.delete(handle);
        throw Error('Shopify SKU could not be verified');
      }

      if (!variant.available) {
        throw Error('This configuration is not available for purchase');
      }

      return variant;
    }

    async add(variant, properties) {
      const response = await this.fetcher(
        new URL(this.route + 'cart/add.js', this.origin).toString(),
        {
          method: 'POST',
          credentials: 'same-origin',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json'
          },
          body: JSON.stringify({
            items: [{
              id: String(variant.id),
              quantity: 1,
              properties
            }]
          })
        }
      );

      const result = await response.json();

      if (!response.ok) {
        throw Error(
          result.description ||
          'Could not add this configuration to your cart'
        );
      }

      if (!result.items?.some(item =>
        String(item.variant_id || item.id) === String(variant.id)
      )) {
        throw Error('Cart result could not be verified');
      }

      return result;
    }
  }

  if (typeof module !== 'undefined' && module.exports) {
    module.exports = StullerCommerce;
  } else {
    scope.StullerCommerce = StullerCommerce;
  }
})(typeof window === 'undefined' ? {} : window);